import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import WorkflowGuidanceStepListResource from '@/modules/workflow/resource/WorkflowGuidanceStepListResource';
import { GenericModel } from '@/modules/core/app/models/GenericModel';

export class WorkflowGuidanceStepListService extends BaseService {
  resource: typeof WorkflowGuidanceStepListResource;

  constructor() {
    super();

    this.resource = WorkflowGuidanceStepListResource;
  }

  getGuidanceStepList(
    selectedJurisdictions: Array<number>,
    selectedEstateTypes: Array<string>
  ): Promise<Array<GenericModel>> {
    return this.resource.getGuidanceStepList(selectedJurisdictions, selectedEstateTypes);
  }
}

export default new WorkflowGuidanceStepListService();
